import { useKernelApi } from 'infrastructure/api';
import { ResourceId } from 'framework/crud';
import presaleRequestValidation from 'domain/sales/opportunity/presale/request/form/presaleRequestValidation';
import {
  showApplicationTypeField,
  showCollaborationExpectationFiled,
  showHasAutomationTestingField,
  showMaterialsField,
  showMobileOSField,
  showPercentTestCoverageField,
  showReplacementReasonField,
  showRequiredFteField,
  showScopeOfWorkField,
  showSystemCompletionField,
  showSystemHostingLocationField,
  showTeamInvolvementField,
  showThirdPartyField,
} from './presaleRequestFieldVisibilityHelper';

const usePresaleOpportunityService = () => {
  const { sendGetRequest, sendPostRequest, sendPutRequest } = useKernelApi();

  const createPresaleRequest = async (opportunityId: ResourceId, request: any) => {
    const response = await sendPostRequest(`/crm/opportunities/${opportunityId}/presale-requests`, request);

    return response.json();
  };

  const updatePresaleRequest = async (opportunityId: ResourceId, presaleId: ResourceId, request: any) => {
    const response = await sendPutRequest(`/crm/opportunities/${opportunityId}/presale-requests/${presaleId}`, request);

    return response.json();
  };

  const getLastPresaleRequest = async (opportunityId: ResourceId) => {
    const response = await sendGetRequest(`/crm/opportunities/${opportunityId}/presale-requests/last`);
    return response.text().then((text: string) => (text ? JSON.parse(text) : null));
  };

  const mapInitialData = (data: any) => {
    return data
      ? {
          requestType: data.requestType,
          expectedCompletionAt: data.expectedCompletionAt,
          systemCompletionProgress: showSystemCompletionField(data) ? data.systemCompletionProgress : null,
          hasPreviousTeamInvolvement: showTeamInvolvementField(data) ? data.hasPreviousTeamInvolvement : null,
          hasAutomatedTesting: showHasAutomationTestingField(data) ? data.hasAutomatedTesting : null,
          automatedTestingCoverage: showPercentTestCoverageField(data) ? data.automatedTestingCoverage : null,
          applicationTypes: showApplicationTypeField(data) ? data.applicationTypes : null,
          mobileOperationSystems: showMobileOSField(data) ? data.mobileOperationSystems : null,
          hasThirdPartyIntegrations: showThirdPartyField(data) ? data.hasThirdPartyIntegrations : null,
          requiredFte: showRequiredFteField(data) ? data.requiredFte : null,
          collaborationExpectations: showCollaborationExpectationFiled(data) ? data.collaborationExpectations : null,
          systemHostingLocation: showSystemHostingLocationField(data) ? data.systemHostingLocation : null,
          replacementReason: showReplacementReasonField(data) ? data.replacementReason : null,
          scopeOfWork: showScopeOfWorkField(data) ? data.scopeOfWork : null,
          materials: showMaterialsField(data) ? data.materials : null,
        }
      : {};
  };

  return {
    createPresaleRequest,
    updatePresaleRequest,
    getLastPresaleRequest,
    mapInitialData,
    getValidationSchema: () => Promise.resolve(presaleRequestValidation),
  };
};

export default usePresaleOpportunityService;
